import { render } from "./SupplierPayments.vue?vue&type=template&id=6810d5f4&scoped=true"
import script from "./SupplierPayments.vue?vue&type=script&lang=js"
export * from "./SupplierPayments.vue?vue&type=script&lang=js"

import "./SupplierPayments.vue?vue&type=style&index=0&id=6810d5f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6810d5f4"]])

export default __exports__